<template>
  <div>

    <el-table
      :data="tableData"
      stripe
      class="table"
      ref="multipleTable"
      header-cell-class-name="table-header"
    >
      <el-table-column label="序号" width="60" align="center">
        <template slot-scope="scope">
          {{scope.$index + 1}}
        </template>
      </el-table-column>
      <el-table-column prop="type" label="反馈类型"></el-table-column>
      <el-table-column prop="content" label="反馈内容"></el-table-column>
      <el-table-column prop="is_read" label="已读"></el-table-column>
      <el-table-column label="创建时间">
        <template slot-scope="scope">
          {{changeTimeDate(scope.row)}}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="220" align="center">

        <template slot-scope="scope">
          <el-button
            type="text"
            icon="el-icon-edit"
            @click="handleUpdata(scope.$index, scope.row)"
          >未读</el-button>

          <el-button
            type="text"
            icon="el-icon-delete"
            class="red"
            @click="handleDelete(scope.$index, scope.row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>

  </div>
</template>

<script>
import {delFeedback, readFeedback} from '../../../../../request/api'
import Utils from '../../../../../js/Utils'

export default {
  name: 'BackFeedbackReadList',
  props: {
    tableData: Array
  },
  methods: {
    // 删除操作
    handleDelete (index, row) {
      console.log(index)
      console.log(row.id)
      var self = this
      // 二次确认删除
      this.$confirm('确定要删除吗？', '提示', {
        type: 'warning'
      })
        .then(() => {
          var params = {'feedback_id': row.id}

          delFeedback(params).then(res => {
            console.log(res)

            if (res.code === '90') {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              self.$emit('refreshFeedbackList', true)
            } else {
              this.$message.error(res.msg)
            }
          }).catch((error) => {
            // error

            console.log(error)
          })
        })
        .catch(() => {})
    },

    handleUpdata (index, row) {
      console.log(index)
      console.log(row.id)
      var self = this

      var params = {'feedback_id': row.id}

      console.log(params)

      readFeedback(params).then(res => {
        console.log(res)

        if (res.code === '90') {
          this.$message({
            type: 'success',
            message: '修改成功!'
          })
          self.$emit('refreshFeedbackList', true)
        } else {
          this.$message.error(res.msg)
        }
      }).catch((error) => {
        // error

        console.log(error)
      })
    },
    changeTimeDate (date) {
      return Utils.formatDate(date.time)
    }
  }
}
</script>

<style scoped>
.handle-box {
  margin-bottom: 20px;
}

.handle-select {
  width: 120px;
}

.handle-input {
  width: 300px;
  display: inline-block;
}
.table {
  width: 100%;
  font-size: 14px;
}
.red {
  color: #ff0000;
}
.mr10 {
  margin-right: 10px;
}
.table-td-thumb {
  display: block;
  margin: auto;
  width: 40px;
  height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/pc/pages/back/feedback/BackFeedbackReadList.vue